export const publicVersion = "2.4.1-102-g3ddfab51-2026-02-13T19-05-51Z";